// ────────────────────────────
// src/components/mainSection.jsx
// ────────────────────────────
import React from "react";
import mainBackground from "../assets/images/background/main_background.png";
import whiteRoutinesIcon from "../assets/images/shapes/routines_icon_white.png";
import whiteProgressIcon from "../assets/images/shapes/progress_icon_white.png";
import whiteDietsIcon from "../assets/images/shapes/diets_icon_white.png";
import "./MainSection.css";

const APP_URL = process.env.REACT_APP_APP_URL || "https://app.zifit.io";

export default function MainSection() {
  return (
    <section
      id="home"
      className="main-section bgs-cover rel z-2 pt-200 pb-250 rpt-150 rpb-50 text-center text-white"
      style={{ backgroundImage: `url(${mainBackground})` }}
    >
      <div className="container">

        <span className="sub-title wow fadeInUp delay-0-2s">
          Aplicación Fitness
        </span>
        
        {/* ——— 1ª línea ——— */}
        <h1 className="mb-0 wow fadeInUp delay-0-4s">
          Plataforma
          <span className="solo-desktop"> Avanzada</span>
        </h1>

        {/* ——— 2ª línea ——— */}
        <h1 className="mb-15 sub wow fadeInUp delay-0-4s">
          <span className="solo-desktop">de </span>Entrenamiento Personal
        </h1>

        <p className="main-subtext wow fadeInUp delay-0-5s">
          Entrenamientos, Nutrición y Progreso.
        </p>

        <div className="main-btns mt-40 wow fadeInUp delay-0-8s d-flex justify-content-center gap-3">
          {/* “Empezar” = mismo layout que Dashboard + colores propios */}
          <a href={APP_URL} className="theme-btn style-five btn-start">
            Prueba Gratis 15 días
          </a>

          {/* <a href="#features" className="theme-btn style-five btn-info">
            Más Información
          </a> */}
        </div>
      </div>

      <div className="section-alpha-text mb-225">ZIFIT</div>
      <img className="routines-shape" src={whiteRoutinesIcon} alt="" />
      <img className="progress-shape" src={whiteProgressIcon} alt="" />
      <img className="diets-shape" src={whiteDietsIcon} alt="" />
      <div className="left-circles" />
      <div className="right-circles" />
    </section>
  );
}
